import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getCommentCount } from '@ifeng-fe/container_content/common/client/services/api';

class CommentUrl extends React.PureComponent {
    static propTypes = {
        docData: PropTypes.object,
    };

    state = {
        allowComment: false,
        count: 0,
    };

    async componentDidMount() {
        const { commentUrl } = this.props.docData;

        try {
            const { join_count, allow_comment } = await getCommentCount(commentUrl);

            this.setState({
                allowComment: allow_comment !== -1,
                count: join_count,
            });
        } catch (e) {
            console.error(e);
        }
    }

    /**
     * 渲染网页布局
     */
    render() {
        const { base62Id } = this.props.docData;
        // console.log(this.props);
        const { allowComment, count } = this.state;

        return (
            allowComment && (
                <li className={styles.comment_container}>
                    <p className={styles.comment_join}>
                        {
                            <a target="_blank" href={`//gentie.ifeng.com/c/comment/${base62Id}`}>
                                {count}
                            </a>
                        }
                        <span className={styles.comment_gif} />
                    </p>
                    <a target="_blank" href={`//gentie.ifeng.com/c/comment/${base62Id}`}>
                        <div className={styles.url_comment} />
                    </a>
                </li>
            )
        );
    }
}

export default errorBoundary(CommentUrl);
